/* Panteer Header R12 07.10.2026: Hauptmenü bleibt immer einzeilig (Freigabe Behnam).
   Wenn der Platz nicht reicht, wird stufenweise verdichtet: 1) weniger Abstand, 2) kleinere Schrift, 3) Emojis ausblenden. */
(function () {
  if (window.__phNavFit) return; window.__phNavFit = true;
  var css = 'html.ph-nav-force .header__inline-menu .list-menu--inline{flex-wrap:nowrap!important}' +
    '.header__inline-menu .list-menu--inline>li>a,.header__inline-menu .list-menu--inline>li summary{white-space:nowrap}' +
    'html.ph-nav-1 .header__inline-menu .list-menu--inline>li>a,html.ph-nav-1 .header__inline-menu .list-menu--inline>li summary{padding-left:.8rem!important;padding-right:.8rem!important}' +
    'html.ph-nav-2 .header__inline-menu .list-menu--inline>li>a,html.ph-nav-2 .header__inline-menu .list-menu--inline>li summary{padding-left:.6rem!important;padding-right:.6rem!important;font-size:1.3rem!important;letter-spacing:0!important}' +
    'html.ph-nav-3 .header__inline-menu .ph-emo{display:none}' +
    'html.ph-nav-3 .header__inline-menu .list-menu--inline>li>a,html.ph-nav-3 .header__inline-menu .list-menu--inline>li summary{padding-left:.5rem!important;padding-right:.5rem!important;font-size:1.25rem!important;letter-spacing:0!important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var root = document.documentElement, LV = ['ph-nav-1', 'ph-nav-2', 'ph-nav-3'];
  var emoRe = /(\p{Extended_Pictographic}️?\s?)/u;
  function wrapEmoji(nav) {
    if (nav.__phEmo) return; nav.__phEmo = true;
    nav.querySelectorAll('.list-menu--inline > li > a, .list-menu--inline > li summary').forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, list = [];
      while ((n = w.nextNode())) if (emoRe.test(n.nodeValue)) list.push(n);
      list.forEach(function (t) {
        var parts = t.nodeValue.split(new RegExp(emoRe.source, 'gu')), frag = document.createDocumentFragment();
        parts.forEach(function (p) { if (!p) return; if (emoRe.test(p) && p.replace(emoRe, '') === '') { var s = document.createElement('span'); s.className = 'ph-emo'; s.textContent = p; frag.appendChild(s); } else frag.appendChild(document.createTextNode(p)); });
        t.parentNode.replaceChild(frag, t);
      });
    });
  }
  function wraps(ul) {
    var li = ul.children, top = null;
    for (var i = 0; i < li.length; i++) { var t = li[i].offsetTop; if (top === null) top = t; else if (Math.abs(t - top) > 4) return true; }
    return false;
  }
  function fit() {
    var nav = document.querySelector('.header__inline-menu'); if (!nav || nav.offsetParent === null) return;
    var ul = nav.querySelector('.list-menu--inline'); if (!ul) return;
    wrapEmoji(nav);
    LV.concat('ph-nav-force').forEach(function (c) { root.classList.remove(c); });
    for (var i = 0; i < LV.length && wraps(ul); i++) root.classList.add(LV[i]);
    if (wraps(ul)) root.classList.add('ph-nav-force');
  }
  var tmr; function later() { clearTimeout(tmr); tmr = setTimeout(fit, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();
/* R18 08.10.2026: mobil öffnet das Lupen-Icon im Header die Such-Ebene (Suchleiste unter dem Header entfällt) */
(function () {
  if (window.__phSearchIcon) return; window.__phSearchIcon = true;
  var mq = window.matchMedia('(max-width: 989px)');
  document.addEventListener('click', function (e) {
    if (!mq.matches || !document.documentElement.classList.contains('custom-search-active')) return;
    var trg = e.target.closest('.header__search summary, .header__search .header__icon--search, .header__search a, .header__search button');
    if (!trg) return;
    var cs = document.querySelector('custom-search');
    if (!cs || typeof cs.openOverlay !== 'function') return;
    e.preventDefault(); e.stopImmediatePropagation();
    var d = trg.closest('details'); if (d) d.removeAttribute('open');
    cs.openOverlay();
  }, true);
})();
